/**
 * 기타 데이터
 */
const OtherData = [
    {
        "book_id": 10671,
        "book_title": "(京城師範學校) 思出の泉 ",
        "book_title_ko": "(경성사범학교) 사출の천 ",
        "publish_date": "1933.00.00",
        "publish_year": 1933,
        "publish_month": 0,
        "publish_day": 0,
        "publisher": "京城師範學校 女子演習科",
        "publisher_ko": "경성사범학교 여자연습과",
        "library": "△",
        "school_id": 52831,
        "primaryname": "京城師範學校",
        "primaryname_ko": "경성사범학교"
    }
]

export default OtherData;